import type { ResponseVaults } from "@/hooks/data/useMapVaults";
import type { Strategies } from "@/../config/swr.config";
import type { ChainType } from "@/types";

import useApi from "@/hooks/api/useApi";

export interface SupVaultErc20 {
  superform_id: string;
  id: string;
  chain: ChainType;
  has_aerc_20_registered: boolean;
}

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-0029995a-4bdb-4b7b-b16d-e443c64d19c7?ctx=documentation
 */
export default function useErc20VaultsCheck(strategy: Strategies = "on-mount", enabled: boolean = true) {
  const { data, isLoading, isError, mutate } = useApi<SupVaultErc20[], ResponseVaults[] | "">(
    {
      path: `/vaults/aerc20/`,
      api: "v2",
    },
    {
      enabled,
      strategy,
      select: data => {
        if (data === "") {
          throw new Error("API response is empty, please report this issue to the support team");
        }
        return data.map(vault => ({
          superform_id: vault.superform_id,
          id: vault.id,
          chain: vault.chain,
          has_aerc_20_registered: vault.has_aerc_20_registered,
        }));
      },
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
